import Color from "../color/Color";
import ShadowCastCallback from "./ShadowCastCallback";

/**
 * @abstract
 * @extends {ShadowCastCallback}
 */
export default class ColoredShadowCastCallback extends ShadowCastCallback {
    /**
     * @param {Color} lightColor 
     * @param {number} lightSourceCastRadius 
     */
    constructor(lightColor, lightSourceCastRadius) {
        super();

        /**
         * @type {Color}
         */
        this.lightColor = lightColor;
        /**
         * @type {number}
         */
        this.lightSourceCastRadius = lightSourceCastRadius;

        /**
         * @constant
         * @private
         * @type {Color}
         */
        this.workingCalculatedLightColor = new Color(1, 1, 1, 1);
    }

    /**
     * @param {Color} lightColor 
     * @param {number} lightSourceCastRadius 
     */
    setValues(lightColor, lightSourceCastRadius) {
        this.lightColor = lightColor;
        this.lightSourceCastRadius = lightSourceCastRadius;
    }

    /**
     * @param {number} radius 
     * @param {number} lightFraction 
     * @returns {Color}
     */
    calculatedLightedColor(radius, lightFraction) {        
        const lightMagnitudeAtRadius = (1.0 - ((1.0 * radius) / (this.lightSourceCastRadius)));

        this.workingCalculatedLightColor.set(this.lightColor);
        this.workingCalculatedLightColor.mul(lightMagnitudeAtRadius * lightFraction);

        return this.workingCalculatedLightColor;
    }

}